export default __webpack_public_path__ + "static/media/ic-manager.300ded20.svg";